import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MateriaMin } from 'src/app/unidad-buscar/models/unidad-setup';
import { ClasePerdida } from '../models/clase-perdida';
import { ClasePerdidaModal } from '../modal/clase-perdida-modal.component';
import { State, getClasePerdidas, getError, getLoading, getUnidadMaterias } from '../state/clase-perdida.selector';
import { ClasePerdidaPageActions } from '../state/actions';

@Component({
    selector: 'app-clase-perdida-shell',
    standalone: false,
    templateUrl: './clase-perdida-shell.component.html',
    styleUrls: ['./clase-perdida-shell.component.scss']
})

export class ClasePerdidaShellComponent implements OnInit {

    idUnidad: number = 0;
    loading$: Observable<boolean>;
    selected$: Observable<ClasePerdida>;
    perdidas$: Observable<ClasePerdida[]>;
    materias$: Observable<MateriaMin[]>;
    errorMessage$: Observable<string>;

    constructor(
        private store: Store<State>,
        private matDialog: MatDialog,
        private route: ActivatedRoute,
    ) { }

    ngOnInit(): void {
        // Do NOT subscribe here because it uses an async pipe
        this.loading$ = this.store.select(getLoading);
        this.perdidas$ = this.store.select(getClasePerdidas);
        this.materias$ = this.store.select(getUnidadMaterias);
        this.errorMessage$ = this.store.select(getError);

        const params = this.route.snapshot.paramMap;
        if (params.has('id')) {
            this.idUnidad = +params.get('id');
        }
        this.store.dispatch(ClasePerdidaPageActions.loadClasePerdidas({ idUnidad: this.idUnidad }));
        this.store.dispatch(ClasePerdidaPageActions.loadUnidadMaterias({ idUnidad: this.idUnidad }));
        this.store.dispatch(ClasePerdidaPageActions.setIdUnidad({ idUnidad: this.idUnidad }));
    }

    new() : void {
        this.store.dispatch(ClasePerdidaPageActions.initializeCurrentClasePerdida());
    }

    save(clasePerdida: ClasePerdida): void {
        this.store.dispatch(ClasePerdidaPageActions.createClasePerdida({ clasePerdida }));
    }

    update(clasePerdida: ClasePerdida): void {
        this.store.dispatch(ClasePerdidaPageActions.updateClasePerdida({ clasePerdida }));
    }

    delete(clasePerdida: ClasePerdida): void {
        this.store.dispatch(ClasePerdidaPageActions.deleteClasePerdida({ clasePerdida }));
    }

    dialogNew() {
        const dialogRef = this.matDialog.open(ClasePerdidaModal, {
            data: { materias$: this.materias$, idUnidad: this.idUnidad }
        });
    }

    getSumaHoras(clasesPerdidas: ClasePerdida[]) {
        const result = clasesPerdidas.reduce((accumulator, obj) => {
            return accumulator + obj.horas;
        }, 0);
        return result > 0 ? result : 0;
    }

}
